import { createFileRoute } from "@tanstack/react-router"

import { PrintTokenPage } from "@/pages/print/print-token-page"

// No auth guard: the token itself (short-lived, Redis-backed) is the credential, mirroring
// /share/selections/$token — a headless browser (Celery PDF-export worker) has no Clerk session.
export const Route = createFileRoute("/print/token/$token")({
	component: PrintTokenPage,
})
